import { BugoData } from '@shared/api/bugo/bugo.interface';
import { GiftItemForStore } from '@shared/api/giftItem/giftItem.interface';
import { GiftItemInfoType } from '@shared/api/giftItemInfo/giftItemInfo.interface';
import {
  GiftOrderCreateDto,
  GiftOrderItemCreateDto,
  GiftOrderItemType,
} from '@shared/api/giftOrder/giftOrder.interface';

// 단일 상품 정보
interface OrderItemInput {
  giftItem: GiftItemForStore;
  quantity: number;
  // 배송형일 때 추가
  receiverAddress?: string;
  receiverPostalCode?: string;
}

interface IParams {
  bugo: BugoData;
  receiverName: string;
  receiverPhoneNumber: string;
  items: OrderItemInput[];
}

/**
 * 다중 상품 GiftOrder DTO 생성
 */
export const getGiftOrderDto = ({
  bugo,
  receiverName,
  receiverPhoneNumber,
  items,
}: IParams): GiftOrderCreateDto => {
  // 총 결제 금액 계산
  const totalPrice = items.reduce((sum, item) => {
    const priceRetail = item.giftItem.priceRetail || 0;
    return sum + priceRetail * item.quantity;
  }, 0);

  // 각 상품별 orderDetail 생성
  const orderDetails: GiftOrderItemCreateDto[] = items.map((item) => {
    const isCouponType = item.giftItem.giftItemInfo?.type === GiftItemInfoType.Coupon;

    const orderDetail: GiftOrderItemCreateDto = {
      giftItem: item.giftItem._id,
      quantity: item.quantity,
      type: isCouponType ? GiftOrderItemType.Coupon : GiftOrderItemType.Delivery,
    };

    // 배송형일 때만 배송 정보 추가
    if (!isCouponType) {
      orderDetail.deliveryDetail = {
        receiverAddress: item.receiverAddress || '',
        receiverPostalCode: item.receiverPostalCode || '',
      };
    }

    return orderDetail;
  });

  return {
    bugo: bugo._id,
    receiverName,
    receiverPhoneNumber,
    orderDetails,
    paymentDetail: {
      paymentByCash: totalPrice,
      paymentByPoint: 0,
    },
    webBaseUrl: process.env.REACT_APP_WEB_BASE_URL,
  };
};

/**
 * 단일 상품용 간편 DTO 생성 (바로구매용)
 */
export const getGiftOrderDtoSingle = ({
  giftItem,
  bugo,
  quantity,
  receiverName,
  receiverPhoneNumber,
  receiverAddress,
  receiverPostalCode,
}: {
  giftItem: GiftItemForStore;
  bugo: BugoData;
  quantity: number;
  receiverName: string;
  receiverPhoneNumber: string;
  receiverAddress?: string;
  receiverPostalCode?: string;
}): GiftOrderCreateDto => {
  return getGiftOrderDto({
    bugo,
    receiverName,
    receiverPhoneNumber,
    items: [
      {
        giftItem,
        quantity,
        receiverAddress,
        receiverPostalCode,
      },
    ],
  });
};
